<template>
    <router-view />
</template>

<script>
export default {
    name: "Roles and Permissions",
};
</script>

<style lang="scss" scoped></style>
